import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQrCodeScan = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "qr-code-scan" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 5.25,
			y: 5.25,
			width: 3,
			height: 3
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 5.25,
			y: 15.75,
			width: 3,
			height: 3
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 15.75,
			y: 5.25,
			width: 3,
			height: 3
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "5.25 12.75 11.25 12.75 11.25 14.25"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "14.25 14.25 14.25 18.75 18.75 18.75 18.75 14.25 17.25 14.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 11.25,
			y1: 17.25,
			x2: 11.25,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "11.25 5.25 11.25 9.75 12.75 9.75"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.75,
			y1: 11.25,
			x2: 18.75,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,6V2.25A1.5,1.5,0,0,1,2.25.75H6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18,.75h3.75a1.5,1.5,0,0,1,1.5,1.5V6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.25,18v3.75a1.5,1.5,0,0,1-1.5,1.5H18"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6,23.25H2.25a1.5,1.5,0,0,1-1.5-1.5V18"
		})
	]
});
export default SvgQrCodeScan;
